export const TAB = {
  STATUS: 'status',
  SCHEDULE: 'schedule',
  CHAT: 'chat',
};

export const TAB_CONFIG = [
  {
    key: TAB.STATUS,
    label: 'common:Situation',
    disabled: () => false,
  },
  {
    key: TAB.SCHEDULE,
    label: 'common:EquipScheduling',
    disabled: ({ dispatchPermission }) => !dispatchPermission,
  },
  {
    key: TAB.CHAT,
    label: 'common:Chat',
    disabled: ({ dispatchPermission, enabledChatStatus }) => (
      !dispatchPermission || !enabledChatStatus
    ),
  },
];

export const CODE_TYPE_COLORS = {
  0: '#D32F2F',
  1: '#FF9800',
  2: '#27AE60',
  3: '#666666',
  4: '#666666',
};

export const STATUS_COMMENT_CHARACTER_LIMIT = 255;

export const SCHEDULE_OBSERVATION_CHARACTER_LIMIT = 500;

export const STATUS_REQUIRED_FIELDS = [
  'code_type',
  'id_code_group',
  'id_code',
  'start_timestamp',
  'id_operator',
  'id_operator_group',
];

export const STATUS_FIELDS_TO_COMPARE = [
  ...STATUS_REQUIRED_FIELDS,
  'comment',
  'sent_from_tablet',
  'element_id',
  'point_id',
  'code_maintenance_id',
  'id_code_type_maintenance',
  'id_code_group_maintenance',
];

export const SCHEDULE_REQUIRED_FIELDS = [
  'group_equipament_links_id',
  'code_types_id',
  'code_groups_id',
  'codes_id',
  'flowchart_element_id',
  'flowchart_element_point_id',
  'start_date',
  'start_time',
  'duration',
  'end_date',
  'end_time',
];

export const SCHEDULE_FIELDS_TO_COMPARE = [
  ...SCHEDULE_REQUIRED_FIELDS,
  'observation',
];
